module.exports = __webpack_public_path__ + "media/images/menu-plus-af550d2b2a8c39c65899c1bc3261924c.png";